import React from 'react';
import PropTypes from 'prop-types';

import {
  AlertContainer,
  AlertIcon,
  AlertMessage,
  AlertTypes,
} from './Alert.styled';

const Alert = (props) => {
  const { alertType, children } = props;
  return (
    <AlertContainer alertType={alertType}>
      <AlertIcon {...props} />
      <AlertMessage>{children}</AlertMessage>
    </AlertContainer>
  );
};

Alert.propTypes = {
  alertType: PropTypes.oneOf(Object.keys(AlertTypes)).isRequired,
  children: PropTypes.node.isRequired,
};

export default Alert;
